import e from"react";import{Button as r}from"./styles.js";const o=({color:o,isNewTab:t,text:l,href:f})=>f?e.createElement(r,{href:f,mode:o,target:t?"_blank":"_self",rel:t?"noopener noreferrer":void 0,fullWidth:!1},l):null;export{o as CTA};
//# sourceMappingURL=CTA.js.map
